import { render, staticRenderFns } from "./pricesup.vue?vue&type=template&id=8a796ff6&"
import script from "./pricesup.vue?vue&type=script&lang=js&"
export * from "./pricesup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports